module.exports = __webpack_public_path__ + "static/media/pointer.fb6de442.svg";